import { render, staticRenderFns } from "./bmap.vue?vue&type=template&id=5e30a288&scoped=true"
import script from "./bmap.vue?vue&type=script&lang=js"
export * from "./bmap.vue?vue&type=script&lang=js"
import style0 from "./bmap.vue?vue&type=style&index=0&id=5e30a288&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e30a288",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e30a288')) {
      api.createRecord('5e30a288', component.options)
    } else {
      api.reload('5e30a288', component.options)
    }
    module.hot.accept("./bmap.vue?vue&type=template&id=5e30a288&scoped=true", function () {
      api.rerender('5e30a288', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/demo/bmap.vue"
export default component.exports